"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
const Card = props => {
  const {
    cardTitle,
    cardText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Card, {
    body: true,
    className: "ixn-card"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.CardTitle, null, cardTitle), /*#__PURE__*/_react.default.createElement(_reactstrap.CardText, null, cardText));
};
exports.Card = Card;
Card.defaultProps = {
  /** Specifies the card heading. */
  cardTitle: '',
  /** Specifies the card body. */
  cardtext: ''
};
Card.propTypes = {
  /** Specifies the card heading. */
  cardTitle: _propTypes.default.string,
  /** Specifies the card body. */
  cardtext: _propTypes.default.string
};